import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
export function AuthorNote() {
  return <section className="w-full bg-[#F5F2EB] py-16 px-4" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-32">
          {/* Profile Photo */}
          <div className="flex-shrink-0 mx-auto md:mx-0" data-id="element-33">
            <div className="w-24 h-24 rounded-full bg-[#1B3022] flex items-center justify-center text-white text-3xl font-serif font-bold shadow-lg" data-id="element-34">
              SS
            </div>
          </div>

          {/* Note Text */}
          <div data-id="element-35">
            <h3 className="font-serif text-2xl font-bold text-[#1B3022] mb-4" data-id="element-36">
              Una nota personal para ti
            </h3>

            <div className="font-serif text-[#3a3a32] text-lg leading-relaxed space-y-4" data-id="element-37">
              <p data-id="element-38">
                Creé este protocolo después de años viviendo solo en Santiago y
                viendo cómo mi sueldo desaparecía en el supermercado sin
                explicación lógica.
              </p>
              <p data-id="element-39">
                No soy chef ni nutricionista. Soy alguien que se cansó de pagar
                de más y decidió aplicar ingeniería a un problema que todos los
                solteros enfrentamos en silencio:{' '}
                <span className="font-semibold text-[#1B3022]" data-id="element-40">
                  el sistema de retail no está diseñado para nosotros.
                </span>
              </p>
              <p data-id="element-41">
                Cada dato, cada tabla y cada recomendación de este protocolo
                viene de auditorías reales que hice personalmente en pasillos de
                supermercados chilenos. Nada es teórico. Todo está probado.
              </p>
              <p data-id="element-42">
                Si estás leyendo esto, ya diste el primer paso. Ahora solo falta
                que actúes.
              </p>
            </div>

            {/* Signature */}
            <div className="mt-8 mb-6" data-id="element-43">
              <p className="font-serif italic text-2xl text-[#1B3022]/70" style={{
              fontFamily: "'Playfair Display', Georgia, serif"
            }} data-id="element-44">
                — El equipo Solo-Survival
              </p>
            </div>

            {/* Credibility Badge */}
            <div className="inline-flex items-center gap-2 bg-[#1B3022]/10 border border-[#1B3022]/20 rounded-full px-5 py-2.5" data-id="element-45">
              <BadgeCheckIcon className="w-5 h-5 text-[#1B3022]" data-id="element-46" />
              <span className="text-sm font-medium text-[#1B3022]" data-id="element-47">
                Basado en auditorías reales de precios en Lider, Jumbo y Alvi
                (Chile 2025-2026)
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}